'use strict';

const isElementOfType = (ReactComponent) => (child) => {
    const element = child;
    return element?.type === ReactComponent || element?.props?.originalType === ReactComponent;
};
const isElement = (child) => !!child?.type;

exports.isElement = isElement;
exports.isElementOfType = isElementOfType;
//# sourceMappingURL=react-elements.js.map
